import { fmtMsg } from "./../../../../commonui/utils/func";
import { Vue, Component } from "vue-property-decorator";
import { ApplicationViews, MethodologyType } from "@/util/enum";
import { Column, Table } from "ant-design-vue/lib";
import { ReportsLocale } from "@/locales/localeid";
import { ReportsModule } from "@/modules/reports-objective";
import ContentExposureRelatedItem from "@/components/content-exposure/content-exposure-relatedItem/content-exposure-relatedItem.vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import { toSeconds } from "@/util/func";

@Component({
	components: {
		Table,
		ContentExposureRelatedItem
	}
})
export default class ComponentObjectives extends Vue {
	public view = ApplicationViews.ComponentObjectives;
	public tableData: [] = [];

	public columns: Column[] = [
		{
			title: fmtMsg(ReportsLocale.ReportsComponentSequence),
			width: "10%",
			dataIndex: "duration",
			scopedSlots: { customRender: "duration" }
		},
		{
			title: fmtMsg(ReportsLocale.ReportsComponentRelatedItems),
			width: "20%",
			dataIndex: "relatedItems",
			scopedSlots: { customRender: "relatedItems" }
		},
		{
			title: fmtMsg(ReportsLocale.ReportsComponentTeachingActivity),
			width: "35%",
			dataIndex: "teachingActivities",
			scopedSlots: { customRender: "activities" }
		},
		{
			title: fmtMsg(ReportsLocale.ReportsComponentObjective),
			width: "35%",
			dataIndex: "objectives",
			scopedSlots: { customRender: "objectives" }
		}
	];

	showTime(start:string,end:string){
		return toSeconds(start) != 0 && toSeconds(end) != 0;
	}

	get contentExposures() {
		return ReportsModule.contentExposures;
	}

	get isRepExposure(){
		return ReportsModule.methodologyType === MethodologyType.REP;
	}

	get showSepratedTime(){
		return !this.isRepExposure;
	}

	get versionGroupId() {
		return VersionGroupModule.selectedGsVersion !== "-1"
			? VersionGroupModule.selectedGsVersion
			: VersionGroupModule.selectedLsVersion;
	}

	get vcsLevelId() {
		return ReportsModule.selectedUnit?.id;
	}

	get contentId() {
		return ReportsModule.contentId;
	}

	get loading() {
		return ReportsModule.isLoading;
	}
}
